<template>
  <div class="footer">
    <div class="footer-top">
      <div class="footer-content">
        <div class="top">
          <div class="left-menu">
            <div class="left-menu-item" v-for="(item, index) in menuList" :key="index" @click="changrRouter(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="icon-box">
            <div class="icon-item">
              <img src="@/assets/images/jituanguanwei.jpg" alt="集团官微"/>
              <span>集团官微</span>
            </div>
            <div class="icon-item">
              <img src="@/assets/images/shipinhao.jpg" alt="视频号"/>
              <span>视频号</span>
            </div>
            <div class="icon-item">
              <img src="@/assets/images/douyinhao.jpg" alt="抖音号"/>
              <span>
                  抖音号
                </span>
            </div>
          </div>
        </div>
        <div class="company-info">
          <div class="logo-section">
            <img src="@/assets/images/logo_f.png" alt="logo" class="footer-logo"/>
          </div>
          <div class="info-text">
            <div class="company-desc">
              <div>
                电话：0479-6902777/6955588
              </div>
              <div>
                邮箱：1375299860@qq.com
              </div>
              <div>
                地址：内蒙古锡林浩特市新区尚城生活G1-G3商务楼
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="footer-bottom">
      <span class="icp-info">Copyright © 2021 中新集团 </span>
      <span class="record-number" @click="openUrl()">蒙ICP备2022003222号-1</span>
    </div>
  </div>
</template>

<script>
import SvgArrow from '@/components/svg-arrow.vue'
import {getBaseInfo, clickColumn} from '@/api/companyConsult'

export default {
  components: {SvgArrow},
  props: {},
  data() {
    return {
      menuList: []
    }
  },
  created() {
    // this.getBaseInfo()
    this.getMenuList()
    console.log(1)
  },
  methods: {
    openUrl() {
      window.open("https://beian.miit.gov.cn/")
    },
    getBaseInfo() {
      // getBaseInfo().then(res => {
      //   if (res.code === 200) {
      //     this.menuList = res.data
      //   }
      // })
    },
    changrRouter(row) {
      if (this.$route.query.id === row.id) return
      this.$router.push({
        path: '/module/module-text',
        query: {
          id: row.id,
          title: row.name,
          type: row.type
        }
      })
    },
    getMenuList() {
      clickColumn({
        columnId: "49c7c3ef453241878893e6de655b0e70",
      }).then(res => {
        this.menuList = res.leftColumn?.webArticleColumnEntities || {}
        console.log(this.leftColumn)
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  background: linear-gradient(71deg, transparent 0, rgba(0, 0, 0, 0.3) 100%), #004b85;

  .footer-top {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;

    .footer-content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      gap: 20px;

      .top {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .left-menu {
        display: flex;
        gap: 14px;

        .left-menu-item {
          font-size: 14px;
          height: 30px;
          font-weight: 500;
          color: #fff;
          margin-bottom: 10px;
          background-color: rgba(0, 0, 0, 0.2);
          padding: 4px 12px;
          border-radius: 15px;
          cursor: pointer;
          transition: all .3s ease;
          display: flex;
          align-items: center;

          &:hover {
            background-color: rgba(0, 0, 0, 0.4);
          }
        }
      }

      .company-info {
        flex: 1;
        display: flex;
        align-items: flex-start;
        gap: 20px;

        .logo-section {
          .footer-logo {
            width: 80px;
            height: auto;
            object-fit: contain;
          }
        }

        .info-text {
          flex: 1;
          color: #fff;

          .company-name {
            font-size: 16px;
            font-weight: bold;
            margin: 0 0 10px 0;
            line-height: 1.4;
          }

          .company-desc {
            //font-weight: 600;
            font-size: 14px;
            line-height: 1.6;
            margin: 0;
            opacity: 0.9;
            display: flex;
            gap: 8px;
            flex-direction: column;
          }
        }
      }

      .icon-box {
        display: flex;
        flex-direction: row;
        gap: 30px;
        align-items: center;

        .icon-item {
          width: 100px;
          height: 100px;
          z-index: 1;
          display: flex !important;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #fff;

          img {
            width: 80px;
            width: 80px;
            object-fit: contain;
            border-radius: 6px;
            margin-bottom: 10px;
          }

          span {
            font-size: 14px;
          }
        }
      }
    }
  }

  .footer-bottom {
    height: 60px;
    background-color: rgba(0, 0, 0, 0.2);
    color: #fff;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .icp-info,
    .record-number {
      opacity: 0.8;
    }
  }
}
</style>
